import instObj from '@/backend/axios-instances'

const resource = "/warehouse"
const instance = instObj.baseInstance

export default {
  get(warehouseId, parameters) {
    return instance.get(`${resource}/${warehouseId}`, { params: parameters });
  },
  put(warehouseId, data, parameters) {
    return instance.put(`${resource}/${warehouseId}`, data, { params: parameters });
  },
  delete(warehouseId) {
    return instance.delete(`${resource}/${warehouseId}`);
  }
}
